import { useMutation, useQueryClient } from 'react-query';

import { updateCompanyPest } from 'api/clients/updateCompanyPest';

const useEditPestCompany = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: editPestCompany,
    isLoading,
  } = useMutation(updateCompanyPest, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    editPestCompany,
    isLoading,
  };
};

export default useEditPestCompany;
